import {useTranslation} from 'react-i18next';
import Button from 'ui/@_components/button';
import useDemoAccount from 'ui/@hooks/use-demo-account';
import DemoBarIcon from 'ui/@_components/kit/icons/demo-bar.svg?react';
import styles from './styles.module.scss';

const DemoAccountBar = () => {
  const {t} = useTranslation('components', {
    keyPrefix: 'page-template.components.demo-account-bar',
  });

  const {isDemoAccount, endDemoAccount} = useDemoAccount();

  const onSetUp = () => {
    endDemoAccount();

    window.location.pathname = '/';
  };

  if (!isDemoAccount) {
    return null;
  }

  return (
    <div className={styles.container}>
      <DemoBarIcon className={styles.pathSvg} />

      <div className={styles.horizontalCurve} />

      <div className={styles.contentWrapper}>
        <p className={styles.title}>{t('title')}</p>

        <Button
          variant="secondary2"
          className={styles.switchBtn}
          onClick={onSetUp}
        >
          {t('setup')}
        </Button>
      </div>
    </div>
  );
};

export default DemoAccountBar;
